import {IMetaActionInfo, EMetaActionType} from 'entities/metadata';

export const generateActionsForFilter = (entityName: string): IMetaActionInfo[] => [
    {
        actionType: EMetaActionType.BUTTON_SEND_FILTER,
        actionCode: 'SEND_FILTER',
        actionTitle: 'Применить',
        referenceUrl: entityName,
    },
    {
        actionType: EMetaActionType.REMOVE_FILTER,
        actionCode: 'REMOVE_FILTER',
        actionTitle: 'Снять фильтры',
        parentEntityName: entityName,
    },
    {
        actionType: EMetaActionType.BUTTON_BACK,
        actionCode: 'CANCEL_PUBLIC',
        actionTitle: 'Отменить',
    },
];

export interface IApplyCustomConditionsArgs {
    entityName: string;
    formValues: any;
}
